"use strict";
// This module computes the donation-reminder render model.
// Input: `LsosProject[]` - the list of open-source projects that use the `@lsos/donation-reminder` package
// Output: `LogFragment[]` - the donation-reminder render model
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDonationReminderLog = void 0;
var getLsosProjectInfo_1 = require("../utils/getLsosProjectInfo");
var components_1 = require("./utils/styled-log/components");
var HEADER_TITLE = "Support Open Source";
var BORDER_GREEN_COLOR = "#00ae41";
/*
const MARGIN_LEFT = 4;
/*/
var MARGIN_LEFT = 0;
//*/
var MARGIN_NOTE_LEFT = 2;
var PROJECT_LOGO_SIZE = 32;
var PROJECT_LOGO_MARGIN_RIGHT = 10;
function getDonationReminderLog(projects, _a) {
    var _b = (_a === void 0 ? {} : _a).showLsosDonationFund, showLsosDonationFund = _b === void 0 ? false : _b;
    return __spreadArrays((showLsosDonationFund
        ? __spreadArrays(getHeader(), components_1.verticalSpace(27)) : components_1.verticalSpace(12)), projects
        .map(getLsosProjectInfo_1.getLsosProjectInfo)
        .map(function (_a, i) {
        var projectName = _a.projectName, iconUrl = _a.iconUrl, donationTextWithEmojis = _a.donationTextWithEmojis, donatePageUrl = _a.donatePageUrl;
        return __spreadArrays(projectLine({
            iconUrl: iconUrl,
            title: projectName,
            description: donationTextWithEmojis,
            link: donatePageUrl,
        }), (i === projects.length - 1 ? [] : components_1.verticalSpace(32)));
    })
        .flat(), (showLsosDonationFund
        ? __spreadArrays(components_1.verticalSpace(32), projectLine({
            iconUrl: getLsosProjectInfo_1.lsosIconUrl,
            title: "Lsos Donation Fund",
            description: "Support all your open source dependencies",
            link: "https://lsos.org/fund",
        }), components_1.verticalSpace(30)) : components_1.verticalSpace(26)), getNote(), (showLsosDonationFund ? __spreadArrays(components_1.verticalSpace(26), getFooter()) : []));
}
exports.getDonationReminderLog = getDonationReminderLog;
function projectLine(_a) {
    var _b;
    var iconUrl = _a.iconUrl, title = _a.title, description = _a.description, link = _a.link;
    var projectLogo = components_1.icon(iconUrl, {
        size: PROJECT_LOGO_SIZE,
    });
    (_b = projectLogo.style).push.apply(_b, [
        "margin-left: " + MARGIN_LEFT + "px",
        "margin-right: -" + (MARGIN_LEFT + PROJECT_LOGO_SIZE) + "px",
    ]);
    var innerMarginStyle = getInnerMarginStyle();
    var descriptionFragments = components_1.injectEmojis(description);
    descriptionFragments = components_1.injectLineBreaks(descriptionFragments);
    descriptionFragments = components_1.injectStyle(descriptionFragments, innerMarginStyle);
    return __spreadArrays([
        projectLogo,
        {
            text: title,
            style: innerMarginStyle,
        },
        separator()
    ], descriptionFragments, [
        separator(),
        {
            text: link,
            style: innerMarginStyle,
        },
    ]);
}
function separator() {
    var innerMarginStyle = getInnerMarginStyle();
    return {
        text: "\xa0| ",
        style: __spreadArrays(innerMarginStyle, ["color: #888"]),
    };
}
function getHeader() {
    return [
        {
            text: HEADER_TITLE,
            style: __spreadArrays(getBorderStyle(), [
                "color: white",
                "padding-top: 10px",
                "padding-bottom: 10px",
            ]),
        },
    ];
}
function getFooter() {
    return [
        {
            text: HEADER_TITLE,
            style: __spreadArrays(getBorderStyle(), [
                "color: " + BORDER_GREEN_COLOR,
                "line-height: 0em",
                "padding-top: 12px",
            ]),
        },
    ];
}
function getBorderStyle() {
    return [
        "background: " + BORDER_GREEN_COLOR,
        "font-size: 2.2em",
        "text-align: center",
        "padding-left: 20px",
        "padding-right: 20px",
        "border-radius: 10px",
    ];
}
function getNote() {
    var codeStyle = [
        "background: rgb(180, 180, 180, 0.2)",
        "padding: 2px 6px",
        "font-size: 0.99em",
        "border-radius: 4px",
    ];
    var noteStyle = ["color: #666", "font-size: 1.2em"];
    return [
        {
            text: "Remove this note by running ",
            style: __spreadArrays(noteStyle, [
                "margin-left: " + (MARGIN_LEFT + MARGIN_NOTE_LEFT) + "px",
            ]),
        },
        {
            text: "npx lsos remove",
            style: codeStyle,
        },
        {
            text: "/",
            style: noteStyle,
        },
        {
            text: "yarn lsos remove",
            style: codeStyle,
        },
        {
            text: ".",
            style: noteStyle,
        },
    ];
}
function getInnerMarginStyle() {
    var INNER_MARGIN_SIZE = MARGIN_LEFT + PROJECT_LOGO_SIZE + PROJECT_LOGO_MARGIN_RIGHT;
    var innerMarginStyle = [
        "margin-left: " + INNER_MARGIN_SIZE + "px",
        "margin-right: -" + INNER_MARGIN_SIZE + "px",
    ];
    return innerMarginStyle;
}
//# sourceMappingURL=getDonationReminderLog.js.map